import { APIService } from "@/services/APIService/APIService";
import { useService } from "@/services/ServiceContext";
import useSWRImmutable from "swr/immutable";
export function useCurrentUser() {
	const svc = useService(APIService.serviceKey);
	return useSWRImmutable("current-user", () => svc.users.getCurrentUser({}));
}

export function useContact(id: string | null | undefined) {
	const svc = useService(APIService.serviceKey);
	return useSWRImmutable(["user", id], () => {
		if (!id) return null;
		return svc.users.getUser({
			id,
		});
	});
}
